import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab"]

  connect() {
    const hash = window.location.hash;
    if (hash) {
      const tabTriggerEl = this.element.querySelector(`button[data-bs-target="${hash}"]`);
      if (tabTriggerEl) {
        const tab = new bootstrap.Tab(tabTriggerEl);
        tab.show();
      }
    }

    // Listen to tab changes
    this.element.addEventListener('shown.bs.tab', (event) => {
      const target = event.target.getAttribute('data-bs-target');
      if (target) {
        window.history.replaceState(null, null, target);
      }
    });
  }
}
